// extracted by mini-css-extract-plugin
export default {"w-full":"Report_w-full__0w48l","backgroundWhite":"Report_backgroundWhite__bopo-"};